(ns manage.content-variant-page.entities.content-optimizing.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [clojure.string :as str]
            [common.ui.entity :refer [query-param->config]]
            [common.ui.list :as ui.list]
            [common.ui.store :as store]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.input :refer [input]]
            [manage.content-configuration-page.view.list :as lv]
            [manage.content-variant-page.entities.content-optimizing.db :as form]
            [manage.content-variant-page.view.list
             :refer [configure-button list-item-details list-item-element]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- optimizing-arms-string
  [ok]
  [list-item-element
   ($ Typography {:fontWeight 600} "Test variant names")
   ($ Typography {:noWrap true} @(rf/subscribe [:optimizing-key/optimizing-arms-as-string (:eid ok)]))])

(def state-button-content
  {"started" {:icon "stop" :label "Stop"}
   "stopped" {:icon "play_arrow" :label "Start"}})

(defn optimizing-key-list-item-details [ok]
  (let [{:keys [state] :as optimization} @(rf/subscribe [:optimizing-key/optimization (:eid ok)])]
    [list-item-details
     [optimizing-arms-string ok]
     [list-item-element
      [:> Stack {:direction "row" :justify-content "space-between" :align-items "center"}
       [configure-button #(rf/dispatch [:optimizing-key/configure (:eid ok)])
        "Configure optimization"]
       (if state
         [:> Button {:start-icon ($ Icon (get-in state-button-content [state :icon]))
                     :on-click #(rf/dispatch [:form.content-optimizing/submit-form
                                              (assoc optimization :state (if (= state "started") "stopped" "started"))])
                     :variant "text"}
          (get-in state-button-content [state :label])]
         [:span "required"])]]]))

(defn- optimizing-key-list-item-cfg
  [ok]
  {:entity/ref ok
   :entity/label :variant-feed-key/name
   :list-item/details [optimizing-key-list-item-details ok]})

(defn list-cfg
  [vf]
  (lv/as-entity
   {:entity/ref vf
    :entity/icon "science"
    :entity/label "Content optimizing"
    :entity/read-only? true
    :list/items [:variant-feed/optimizing-keys (:eid vf)]
    :list/->item-cfg optimizing-key-list-item-cfg
    :list/empty-msg
    ($ ui.list/empty-msg {:title "Classify your optimizing columns"}
       ($ :p
          "To use content optimizing, classify column(s) of your feed as Optimizing key, in your "
          ($ ui.list/empty-msg-button {:onClick #(rf/dispatch [:form.content-variant/open])}
             "feed configuration")
          ". These columns should contain the test's variant names as values.")
       ($ :p
          "Once the optimizing columns have been classified, you can
           configure them here by choosing an optimization algorithm."))}))

(defui learning-budget-field []
  (let [{:keys [on-change] :as control} (form/use-bind-control [:algorithm-config :learningbudget])]
    ($ form-field
       {:label "Learning budget"}
       ($ input
          (merge control
                 {:type "number"
                  :inputProps #js {:min 0 :max 100}
                  :on-change (fn [e]
                               (let [value (.. e -target -value)
                                     lower-bound (.. e -target -min)
                                     upper-bound (.. e -target -max)
                                     bounded-value (if (str/blank? value)
                                                     "0"
                                                     (min (max (js/parseInt lower-bound)
                                                               (js/parseInt value))
                                                          (js/parseInt upper-bound)))]
                                 (on-change bounded-value)))
                  :sx #js {:width 120}}))
       ($ hint "The percentage of impressions that will be allocated equally over all remaining variants
                after allocating hundred percent minus the learning budget to the variant with the highest CTR"))))

(def algorithm-config-key->field
  {:learningbudget learning-budget-field})

(defui content []
  (let [algorithm-config-keys (use-subscribe [:form.content-optimizing/algorithm-config-keys])
        algorithm-config-fields (select-keys algorithm-config-key->field algorithm-config-keys)]
    ($ Stack {:p 3 :spacing 3}
       ($ form-field
          {:label "Algorithm"
           :err-msg (form/use-error-message [:algorithm])}
          (r/as-element
           [dropdown (merge (form/use-bind-control [:algorithm]
                                                   {:on-change-event :form.content-optimizing/on-change-algorithm})
                            {:auto-focus true
                             :options (use-subscribe [:form.content-optimizing/algorithm-options])})]))
       (for [[field-id field-view] algorithm-config-fields]
         ($ field-view {:key field-id})))))

(defn entity-view-cfg [ok]
  {:entity/ref ok
   :entity/icon "science"
   :entity/label :variant-feed-key/name
   :entity/on-activate [[:resource.content-optimizing/get-algorithms]
                        [:optimizing-key/configure (:eid ok)]]
   :entity/read-only? true
   :entity/content ($ content)})

(defmethod query-param->config :content-optimization
  [{optimizing-key-name :name}]
  (some-> @(rf/subscribe [:ui.store/lookup :variant-feed-key/name optimizing-key-name])
          first store/->DataScriptDBEntity entity-view-cfg))
